module.exports = require('./src/wordCloud');


//////////////////
// WEBPACK FOOTER
// ./~/echarts-wordcloud/index.js
// module id = 1232
// module chunks = 0